/** Port of the mock's entity-chip helper, using the entity/company vocabulary. */

/** Two initials from the company name; the code only when the name has no letters. */
export function initialsOf(name: string, code: string): string {
  const words = name.match(/[\p{L}\p{N}]+/gu) ?? [];
  const letters = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
  return letters || code.slice(0, 2).toUpperCase();
}

export function CompanyChip({ entityId, name, code }: { entityId: string; name: string; code: string }) {
  return (
    <span className="row-tight" data-entity-id={entityId}>
      <span className="avatar" style={{ width: 20, height: 20, fontSize: 9 }} title={code}>
        {initialsOf(name, code)}
      </span>
      <span>{name}</span>
    </span>
  );
}
